// Dispatch
export const updateExtraFieldsAction = (workorderId, extraFieldAnswers) => dispatch =>
  dispatch({
    type:    UPDATE_EXTRA_FIELDS.ACTION,
    payload: { workorderId, extraFieldAnswers }
  })

// Reducer response
export const UPDATE_EXTRA_FIELDS = {
  ACTION: 'UPDATE_EXTRA_FIELDS',

  call: ({ state, workorderId, extraFieldAnswers }) => ({
    ...state,
    items: state.items.map(item => item.id != workorderId ? item : {
      ...item,
      synced: false,
      extra_field_answers: extraFieldAnswers
    })
  })
}
